<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="col-sm-12 list-content pt-1">
      <vue3-datatable
          ref="resultTable"
          :rows="results"
          :columns="fields"
          :pagination="false"
          :sticky-header="true"
          height="55vh"
          :sortable="true"
          skin="bh-table-compact"
          row-class="routa-table-row"
          cell-class="routa-table-cell"
          @row-click="emitDetails"
      >
          <template #completed_time="row">
              <span>{{ toLocalTime(row.value.completed_time) }}</span>
          </template>
          <template #status="row">
              {{ row.value.status === 1 ? $t('area_report.status_open') : $t('area_report.completed') }}
          </template>
      </vue3-datatable>

  </div>
</template>

<script>
import {areaReportHelper} from '../../mixins/AreaReportMixin'
import {timeUtils} from '../../mixins/TimeUtils'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'AreaContractReportList',
    components: {Vue3Datatable},
    mixins: [areaReportHelper, timeUtils],
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            sortBy: 'completed_time',
            sortDesc: true,
            fields: [
                {field: 'area.name', label: this.$t('area_report.area_name'), sortable: true},
                {field: 'completed_time', label: this.$t('area_report.completed'), sortable: true},
                {field: 'status', label: this.$t('area_report.status'), sortable: true}
            ]
        }
    },
    methods: {
        emitDetails: function (details) {
            this.$emit('inspectionSelected', details)
        }
    }
}
</script>
